import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

/**
 * "Continue Shopping" for the cart page: the way back to search, placed under
 * the primary checkout action the way checkout places "Back to Cart" under its
 * own. Styled to match that link (`BackToCartLink`) so the two read as the same
 * kind of control on either side of the flow.
 */
export function ContinueShoppingLink() {
  return (
    <Link
      to="/search"
      className="inline-flex items-center gap-1 rounded text-sm font-medium text-purple-600 hover:text-purple-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2"
    >
      <ArrowLeft className="h-4 w-4" aria-hidden="true" />
      Continue Shopping
    </Link>
  );
}
